import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import "../../static/style/wp-content.css";

class FiveOhFive extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <h1>
            <FormattedMessage
              id="app.error.505.title"
              defaultMessage="Palvelinvirhe"
            />
          </h1>
          <p>
            <FormattedMessage
              id="app.error.505.description"
              defaultMessage="Palvelimella tapahtui odottamaton virhe. Yritä hetken kuluttua uudelleen."
            />
          </p>
        </div>
      </div>
    );
  }
}

export default FiveOhFive;



// WEBPACK FOOTER //
// ./src/containers/static/FiveOhFive.js